import {AppPage} from "common/Layout";
import {AppFlex} from "shared/UI/UIKit/Flex";
import {AppText} from "shared/UI/UIKit/Text";
import type {LiteraturePage as LiteraturePageType} from "../../config/types";
import {GLOBAL_CONFIG} from "../../config/config";
import {PageType} from "../../config/types";
import styles from "./styles.module.scss";

export const LiteraturePage = () => {
  const literaturePage = GLOBAL_CONFIG.pages.find(page => page.type === PageType.LITERATURE) as LiteraturePageType;

  if (!literaturePage) {
    return null;
  }
  return (
    <AppPage contentClassName={styles.content}
             pageTitle="Литература"
             documentTitle="Литература">
      <AppFlex unit="35">
        <AppText size={24} className={styles.title}>Литература</AppText>
        <ol className={styles.list}>
          {
            (literaturePage.items || []).map((item, index) => {
              return (
                <li key={index} className={styles.item}>
                  {item}
                </li>
              );
            })
          }
        </ol>
      </AppFlex>
    </AppPage>
  );
};
